import type { Expense, Wallet } from "@/types";
import { formatCOP, formatNumber } from "@/utils/format";

const ORDER: Wallet[] = ["Bancolombia", "Daviplata", "Nequi", "Caja Social", "Efectivo"];

// Desglose de gastos y caja menor agrupado por billetera / cuenta.
const ExpenseWallets = ({ expenses }: { expenses: Expense[] }) => {
  const total = expenses.reduce((a, e) => a + e.amount, 0);
  const allWallets = Array.from(
    new Set<Wallet>([...ORDER, ...expenses.map((e) => e.wallet)])
  );

  const rows = allWallets
    .map((wallet) => {
      const items = expenses.filter((e) => e.wallet === wallet);
      return {
        wallet,
        amount: items.reduce((a, e) => a + e.amount, 0),
        count: items.length,
      };
    })
    .filter((r) => r.count > 0)
    .sort((a, b) => b.amount - a.amount);

  return (
    <div className="glass-panel rounded-lg">
      <div className="px-5 py-4 border-b border-accent-500/15 flex items-center gap-2">
        <span className="w-8 h-8 rounded-md bg-primary-500/25 text-primary-100 flex items-center justify-center">
          <i className="ri-bank-card-line" />
        </span>
        <div>
          <h3 className="editable-title text-base font-bold">Gastos por billetera</h3>
          <p className="text-[11px] text-foreground-500">Movimiento total: {formatCOP(total)}</p>
        </div>
      </div>

      {rows.length === 0 ? (
        <div className="px-5 py-10 text-center">
          <span className="mx-auto w-12 h-12 rounded-lg bg-background-200/50 text-accent-200 flex items-center justify-center mb-3">
            <i className="ri-wallet-3-line text-2xl" />
          </span>
          <p className="text-sm text-foreground-700 font-semibold">Sin movimientos para desglosar</p>
          <p className="text-xs text-foreground-500 mt-1">
            Registra gastos o caja menor y aquí verás cuánto sale de cada billetera.
          </p>
        </div>
      ) : (
        <ul className="px-5 py-4 space-y-3.5">
          {rows.map((r) => {
            const pct = total > 0 ? Math.round((r.amount / total) * 100) : 0;
            return (
              <li key={r.wallet}>
                <div className="flex items-center justify-between gap-3 mb-1.5">
                  <span className="text-sm font-semibold text-foreground-800 flex items-center gap-2">
                    <i className="ri-wallet-3-line text-foreground-500" />
                    {r.wallet}
                    <span className="text-[10px] text-foreground-500">
                      ({formatNumber(r.count)} mov.)
                    </span>
                  </span>
                  <span className="text-sm font-bold text-foreground-950 whitespace-nowrap">
                    {formatCOP(r.amount)}
                  </span>
                </div>
                <div className="h-1.5 rounded-full bg-background-300/40 overflow-hidden">
                  <div
                    className="h-full rounded-full bg-accent-500"
                    style={{ width: `${pct}%` }}
                  />
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default ExpenseWallets;